<template>
  <div class="box full">
    <div class="box-header">
      {{ $t("message.products_sync.title") }}
    </div>
    <div class="box-content-block pt-4">
      <div class="mb-4">
        <button
          class="btn-error-button"
          @click="sendUpdatesToSearch"
          :class="{ 'btn-info-button': sendingToSearch }"
        >
          <span v-if="!sendingToSearch">
            {{ $t("message.product_modal.general.send_to_search") }}
          </span>
          <span v-else class="flex flex-row">
            <BaseMiniSpinner class="mr-2"></BaseMiniSpinner>
            {{ $t("message.product_modal.general.send_to_search") }}...
          </span>
        </button>
      </div>
      <template v-if="!infoautoLoading">
        <div>
          <h3>
            {{ $t("message.products_sync.infoauto") }}
          </h3>
          <button
            class="btn-dark-button my-20 h-14 w-52 text-center flex justify-center items-center"
            @click="getInfoautoData"
          >
            <span v-if="!infoautoLoading">
              {{ $t("message.products_sync.get_info") }}
            </span>
            <BaseMiniSpinner :loading="true" v-else></BaseMiniSpinner>
          </button>
        </div>
        <div v-if="response">
          <h2>{{ $t("message.products_sync.response") }}</h2>
          <div style="max-width: 600px;" class="text-left">
            <vueJsonEditor
              v-model="response"
              :show-btns="false"
              :expandedOnStart="true"
            />
          </div>
        </div>
      </template>
      <template v-else>
        <BaseLoading :infoautoLoading="true"></BaseLoading>
      </template>
    </div>
  </div>
</template>
<script>
import { infoautoUpdateSinglePart } from "@/api/store/Infoauto.js";
import { updateSearchProduct } from "@/api/store/ProductsService.js";
import vueJsonEditor from "vue-json-editor";

export default {
  name: "ProductSyncInfoauto",
  components: {
    vueJsonEditor
  },
  props: {
    code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      infoautoLoading: false,
      sendingToSearch: false,
      response: null
    };
  },
  methods: {
    sendUpdatesToSearch() {
      this.sendingToSearch = true;
      updateSearchProduct(this.code)
        .then(() => {
          this.$toast.open({
            message: "Update requested",
            type: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.$toast.open({
            message: "Error creating request",
            type: "error",
            position: "top-right"
          });
        })
        .finally(() => {
          this.sendingToSearch = false;
        });
    },
    async getInfoautoData() {
      this.response = null;
      this.infoautoLoading = true;
      try {
        this.response = await infoautoUpdateSinglePart(this.code);
        if (this.response.status === "error") {
          this.$toast.open({
            message: this.response.message,
            type: "error",
            position: "top-right"
          });
        } else {
          this.$toast.open({
            message: "part updated",
            type: "success",
            position: "top-right"
          });
          this.$emit("partUpdated");
        }
        this.$emit("partUpdated");
      } catch (e) {
        this.$toast.open({
          message: e.response.data,
          type: "error",
          position: "top-right"
        });
      }
      this.infoautoLoading = false;
    }
  }
};
</script>
